import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardActions, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import { addItemToCart, removeItemFromCart } from '../redux/cartSlice';

const CartItemsTable = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector(state => state.cart.items); // Adjust according to your state structure

  const handleIncreaseQuantity = (item) => {
    dispatch(addItemToCart({ id: item.id, quantity: 1 })); // Increase by 1
  };

  const handleDecreaseQuantity = (item) => {
    if (item.quantity > 1) {
      dispatch(removeItemFromCart(item.id)); // Decrease by 1
    }
  };

  const handleDeleteItem = (item) => {
    dispatch(removeItemFromCart(item.id)); // Remove item
  };

  return (
    <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Image</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Total</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cartItems.map(item => {
            const totalPrice = item.price * item.quantity;
            return (
              <TableRow key={item.id}>
                <TableCell>
                  <img src={item.imgSrc} alt='cart' height='100px' width='70px' />
                </TableCell>
                <TableCell>
                  <Typography variant="h6" component="div">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    By: <span style={{ color: '#0088DP' }}>{item.author}</span>
                  </Typography>
                </TableCell>
                <TableCell>
                  <CardActions sx={{ padding: 0 }}>
                    <IconButton onClick={() => handleDecreaseQuantity(item)} disabled={item.quantity === 1}>
                      <RemoveIcon />
                    </IconButton>
                    <Typography variant="body2">{item.quantity}</Typography>
                    <IconButton onClick={() => handleIncreaseQuantity(item)}>
                      <AddIcon />
                    </IconButton>
                  </CardActions>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">₹{item.price}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">₹{Number(totalPrice).toFixed(2)}</Typography>
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleDeleteItem(item)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CartItemsTable;
